// Detect a "/@username" profile-mention link in rendered markdown. Lives beside the other markdown-pipeline
// utils (remark_dropcap, ampersand_wrapper) so the mention logic stays with the processor, per the dropcap
// pattern: core-content's `a` component override uses this to swap a mention link for the UserPopover card.

/**
 * The profile slug for a `/@username` mention href, or null. Matches exactly the profile path (with an
 * optional trailing slash) — a deeper path like `/@user/settings` is a normal link, not a mention.
 */
export const usernameFromMentionHref = (href?: unknown): string | null => {
  if (typeof href !== "string") return null
  const match = /^\/@([\w.-]+)\/?$/.exec(href)
  return match ? match[1] : null
}

export default usernameFromMentionHref
